'use client'

import React, { useState } from 'react'

import startCase from 'lodash/startCase'
import NextImage from 'next/image'

import type { ImageProps, ImageSizingProps } from './types'
import useImageLoader from './use-image-loader'

const LocalImage = (props: ImageProps) => {
  const ref = React.createRef<HTMLImageElement>()
  const [loaded, setLoaded] = useState(false)
  const { image: filename, imgProps = {}, sizingProps = {}, origin, placeHolder } = props
  const { minWidth, nativeWidth, nativeHeight, sizes, quality } = sizingProps as ImageSizingProps
  const { alt } = imgProps
  const onLoad = useImageLoader({ ref, origin, onLoaded: () => setLoaded(true) })

  const width = nativeWidth || minWidth
  const height = !nativeHeight || nativeHeight === 'auto' ? undefined : Number(nativeHeight)

  // Build style object - always include width and height auto to prevent Next.js warnings
  const baseStyle: React.CSSProperties = {
    objectFit: 'contain',
    width: 'auto',
    height: 'auto',
    ...imgProps.style,
  }

  if (!loaded && placeHolder) {
    return placeHolder
  }

  return (
    <NextImage
      {...imgProps}
      ref={ref}
      src={`/images/${filename}`}
      style={baseStyle}
      sizes={sizes}
      quality={quality ? Number(quality) : undefined}
      fill={width ? undefined : true}
      width={width}
      height={height}
      onLoad={onLoad}
      data-origin={`local-${origin}`}
      data-attributes={process.env.NODE_ENV === 'production' ? '' : JSON.stringify(props)}
      loading={imgProps.loading}
      alt={alt || startCase((filename as string).split('.')[0])}
    />
  )
}

export default LocalImage
